import React from 'react';
import Navigationbar from './Navigationbar';

const Header = () => {
    return (
        <div>
            <Navigationbar></Navigationbar>
        </div>
    );
};

export default Header;